import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import {
    v2_projects,
    v2_ships,
} from '../../../actions/v2/projectAndVessel';
import {
    v3_fetchNewBuildingFinalDeliveryDocumentChecksheetFields,
    v3_submitNewBuildingFinalDeliveryDocumentChecksheet,
} from '../../../actions/v3/productionForm';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import FlatFormBuilder from '../../../components/Production/Form/NewBuildingFinalDeliveryDocumentChecksheet/index';
import constant from '../../../constant';
import moment from 'moment';
import Swal from 'sweetalert2';

const PreLaunchingChecklist = (props) => {
    const location = useLocation();
    const { data } = location.state || {};
    // 1. Rename state to items (flat list)
    const [items, setItems] = useState([
        { id: '', label: '', remarks: '', statusOfCompletion: '', active: true },
    ]);

    const [commonDetails, setCommonDetails] = useState({
        project: { value: '', options: [], error: '' },
        ship: { value: '', options: [], error: '' },
        date: { value: moment().format('YYYY-MM-DD'), error: '' },
        finalSubmit: { value: false },
        siteManager: { value: '' },
    });

    const [showLoader, setShowLoader] = useState(false);

    // Load projects
    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        });
    }, []);

    // Load ships when project changes
    useEffect(() => {
        if (commonDetails.project.value) {
            v2_ships(null, commonDetails.project.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [commonDetails.project.value]);

    // Fetch checklist items (flat) and commonDetails if editing
    useEffect(() => {
        setShowLoader(true);
        const params = data ? JSON.parse(atob(data)) : {};
        v3_fetchNewBuildingFinalDeliveryDocumentChecksheetFields(
            params.PROJECT_ID,
            params.SHIP_ID
        )
            .then((res) => {
                if (res.status) {
                    // set common details if editing
                    if (params.PROJECT_ID) {
                        setCommonDetails((prev) => ({
                            ...prev,
                            project: { ...prev.project, value: res.result.commonDetails?.PROJECT_ID },
                            ship: { ...prev.ship, value: res.result.commonDetails.SHIP_ID },
                            date: { ...prev.date, value: res.result.commonDetails.SUBMISSION_DATE },
                            finalSubmit: { value: Boolean(res.result.commonDetails.FINAL_SUBMITTED) },
                            siteManager: { value: res.result.commonDetails?.SITE_MANAGER_NAME },
                        }));
                    }
                    // set flat items array
                    setItems(
                        res.result.items.map((item) => ({
                            ...item,
                            statusOfCompletion:
                                item.statusOfCompletion === 'Y'
                                    ? 'yes'
                                    : item.statusOfCompletion === 'N'
                                        ? 'no'
                                        : ''
                        })) || []
                    );
                } else {
                    toast.error(res.error);
                }
            })
            .catch(() => toast.error('Something went wrong while fetching.'))
            .finally(() => setShowLoader(false));
    }, []);

    // Handle changes to a single item
    const handleChange = (index, field, value) => {
        const updated = [...items];
        updated[index][field] = value;
        setItems(updated);
    };

    const onSubmit = async () => {
        // Basic validation
        const errors = [];
        if (!commonDetails.project.value) errors.push('Select a project.');
        if (!commonDetails.ship.value) errors.push('Select a ship.');
        if (!commonDetails.date.value) errors.push('Select a date.');


        if (commonDetails.finalSubmit.value) {
            items.forEach((item, idx) => {
                if (!item.statusOfCompletion) {
                    errors.push(`Item #${idx + 1}: Remarks & Status required.`);
                }
            });
        }

        if (errors.length > 0) {
            toast.error(errors.join('\n'));
            return;
        }
        // If final submit is true, confirm before proceeding
        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });

            if (!confirmResult.isConfirmed) return;
        }
        // Build payload
        const checklistItems = items.map((item) => {
            const record = {
                ITEM_NAME: item.label,
                ITEM_ID: item.id,
                REMARK: item.remarks,
                STATUS_OF_COMPLETION:
                    item.statusOfCompletion === 'yes' ? 'Y' :
                        item.statusOfCompletion === 'no' ? 'N' : '',
                REFERENCE_DOCUMENTS: item.referenceDocument
            };
            if (item.entryId) record.ID = item.entryId;
            return record;
        });

        const payload = {
            // A fresh form must replace any old draft rows for this project/hull
            // with the items loaded from the current configuration.
            replaceConfigurationSnapshot: !data,
            commonDetails: {
                project: commonDetails.project.value,
                ship: commonDetails.ship.value,
                date: commonDetails.date.value,
                finalSubmit: commonDetails.finalSubmit.value,
            },
            checklistItems,
        };

        setShowLoader(true);
        v3_submitNewBuildingFinalDeliveryDocumentChecksheet(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message);
                    props.history.push(
                        constant.Authedcomponent.submittedNewBuildingFinalDeliveryDocumentChecksheet.url);
                } else {
                    toast.error(res.error);
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error(err);
            });
    };

    return (
        <Layout title="Final Delivery Document Checksheet">
            <div className="card">
                <div className="card-body">
                    <div className="checklist-title-bx">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="text-center">
                                    <h4>Final Delivery Document Checksheet</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-md-12 ">
                            <div class="report-index-top">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td class="hd-s2 pl10"><p>Date</p></td>
                                            <td class="td-input-bx"><input
                                                type="date"
                                                className="form-control"
                                                value={commonDetails.date.value}
                                                onChange={(e) =>
                                                    setCommonDetails((prev) => ({
                                                        ...prev,
                                                        date: { ...prev.date, value: e.target.value },
                                                    }))
                                                }
                                            /></td>
                                            <td class="hd-s2 pl10"><p>Project</p></td>
                                            <td class="td-input-bx">
                                                <select
                                                    className="form-select"
                                                    value={commonDetails.project.value}
                                                    disabled={data ? true : false}
                                                    onChange={(e) =>
                                                        setCommonDetails((prev) => ({
                                                            ...prev,
                                                            project: { ...prev.project, value: e.target.value },
                                                        }))
                                                    }
                                                >

                                                    <option value={''}>Select Project</option>
                                                    {commonDetails.project.options.map((item) => {
                                                        return (<option value={item.ID}>{item.PROJECT_CODE} - {item.PROJECT_NAME}</option>)
                                                    })}
                                                </select>

                                            </td>


                                            <td class="hd-s2 pl10"><p>Hull No</p></td>
                                            <td class="td-input-bx">
                                                <div class="hull-select-box">
                                                    <select
                                                        className="form-control"
                                                        disabled={data ? true : false}
                                                        value={commonDetails.ship.value}
                                                        onChange={(e) =>
                                                            setCommonDetails((prev) => ({
                                                                ...prev,
                                                                ship: { ...prev.ship, value: e.target.value },
                                                            }))
                                                        }
                                                    >

                                                        <option value={''}>Select Hull</option>
                                                        {commonDetails.ship.options.map((item) => {
                                                            return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                        })}
                                                    </select>

                                                </div>

                                            </td>



                                        </tr>

                                    </tbody>
                                </table>

                            </div>

                        </div>
                    </div>
                    <FlatFormBuilder
                        items={items}
                        onChange={handleChange}
                        siteManager={commonDetails.siteManager.value}
                        onSubmit={() => onSubmit()}
                        setItems={setItems}
                        isFinalSubmitting={commonDetails.finalSubmit.value}
                        setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                            ...prev,
                            finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                        }))}
                    />


                </div>
            </div>
        </Layout>
    );
};

export default PreLaunchingChecklist;
